import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from '../../../../elements/field-error/field-error';
import { TextArea } from '../../../../elements/text-area';
import { DatePicker } from '../../../../elements/date-picker';



// construccion del objeto yup de validacion del cuestionario
let obligado = {
    mileage: Yup.string().required('obligatorio'),
    date: Yup.mixed().required('obligatorio'),
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    mileage: '',
    date: '',
};

export const ControlKmTabForm = ({
    item,
    vehicleId,
    close,
    doDelete
}: {
    item?: any;
    vehicleId?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);


    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        if (!item) {
            after.vehicle = vehicleId;
        } else {
            after.vehicle = after.vehicle.id;
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/mileage-checks/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/mileage-checks/', 'POST', enviaremos);
        }
    };



    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('mileage-checks')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }else{
                 toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">

                    <Input
                        label={t('common.label.km-control')}
                        type="number"
                        placeholder={t('common.label.km-control')}
                        name="mileage"
                        value={values.mileage}
                        onChange={(value) =>
                            setFieldValue('mileage', value.mileage)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'mileage'}
                    />




                    <div className='pt-2'>
                        <DatePicker
                            name="date"
                            type="date"
                            label={t(
                                'common.labels.date'
                            )}
                            value={
                                (data
                                    ? dayjs(
                                        data.date
                                    ).format(
                                        'YYYY-MM-DD'
                                    )
                                    : '') ||
                                values.date
                            }
                            onChange={(value) => {
                                setFieldValue(
                                    'date',
                                    value.date
                                        ? dayjs(
                                            value.date
                                        ).format(
                                            'YYYY-MM-DD'
                                        )
                                        : null
                                );
                            }}
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'date'}
                        />
                    </div>

                    <div className='pt-2'>
                        <TextArea
                            label={t(
                                'common.label.observaciones'
                            )}
                            placeholder={t(
                                'common.label.observaciones'
                            )}
                            name="observations"
                            value={values.observations}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'observations',
                                    value.observations
                                )
                            }
                        />
                    </div>




                    <div className='pt-48'></div>


                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};